module.exports = __webpack_public_path__ + "media/application/images/icons/blue-arrow-b741a481f882ed3c5feffb678a482f00.svg";